import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../redux/slices/snackbar";
import useAuth from "../../../hooks/useAuth";
import { a11yProps } from "../../../utils/common";
import TabPanel from "../../../components/TabPanel";

import {
  Alert as MuiAlert,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  CardHeader,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import { spacing } from "@mui/system";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";

import SaveCancel from "../../../components/SaveCancel";
import useEmployee from "../../../hooks/useEmployee";
import EmployeeFields from "./components/EmployeeFields";
import MenuAclFields from "./components/MenuAclFields";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Card = styled(MuiCard)(spacing);

const Alert = styled(MuiAlert)(spacing);

const useTabStyles = styled({
  root: {
    justifyContent: "center",
    width: "1000px",
  },
  scroller: {
    flexGrow: "0",
  },
});

const validationSchema = Yup.object().shape({
  businessType: Yup.string().required("Required"),
  tenant: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required(),
  branchName: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required(),
  emailId: Yup.string().required("Required"),
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  userName: Yup.string().required("Required"),
  address: Yup.string().required("Required"),
  mobileNo: Yup.string()
    .required("Required")
    .matches(/^\d{10}$/, "Must be a valid phone number with up to 10 digits"),
  status: Yup.string().required("Required"),

  confirmPassword: Yup.string().when("password", {
    is: (val) => (val && val.length > 0 ? true : false),
    then: () =>
      Yup.string()
        .required()
        .oneOf([Yup.ref("password")], "Both password need to be the same"),
  }),
});

function EditEmployee(props) {
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const dispatch = useDispatch();
  const classes = useTabStyles();
  const { getEmployee, employee, updateEmployee, isSubmitting } = useEmployee();

  React.useEffect(() => {
    if (Object.keys(employee).length !== 0) {
      console.log(employee.status, "employee.status");
      const initialValues = {
        employeeId: employee.employeeId,
        tenant: {
          label: employee.tenant?.tenantName,
          value: employee.tenant?.tenantId,
        },
        branchName: {
          label: employee.branch?.branchName,
          value: employee.branch?.branchId,
        },
        firstName: employee.firstName,
        lastName: employee.lastName,
        status: employee.status,
        address: employee.address,
        mobileNo: employee.mobileNo,
        emailId: employee.emailId,
        userName: employee.userName,
      };
      reset(initialValues);
    }
  }, [employee]);

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });

  const [status] = useState({
    sent: false,
  });
  const { user } = useAuth();

  const { state } = useLocation();
  console.log(state, "location");
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    reset,
    handleSubmit,
    setValue,
    formState: {},
  } = methods;

  useEffect(() => {
    if (user) {
      setValue("tenant", {
        label: user.name,
        value: user.tenantId,
      });
    }
  }, [user]);

  const [tabValue, setTabValue] = React.useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const onSubmit = async (data) => {
    try {
      data["tenant"] = {
        tenantId: data.tenant.value,
      };

      data["branch"] = {
        branchId: data.branchName.value,
      };
      let menuAcls = [];
      if (selectedPermissions.length == 0) {
        dispatch(showErrorSnackbar("Please select the menu acl"));
        return;
      }
      console.log(selectedPermissions, "jkljjjjjjjj");
      for (const index in selectedPermissions) {
        const key = index.split("-");
        menuAcls.push({
          rolePermissionId: Number(key[0]),
          isEnabled: selectedPermissions[index],
        });
      }
      data["menuAcl"] = menuAcls;
      await updateEmployee(data);

      dispatch(showSuccessSnackbar("Employee  updated successfully!"));
      navigate("/cpanel/employee/list");
    } catch (err) {
      console.log(err, "ddddddddddddd");
      dispatch(showErrorSnackbar("Failed to edit employee "));
    }
  };

  const cancelBtn = () => {
    navigate("/cpanel/employee/list");
  };

  const breadCrump = () => {
    return (
      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Typography>Employee</Typography>
        <Typography>Edit</Typography>
      </Breadcrumbs>
    );
  };

  const fetchData = async () => {
    await getEmployee(state.id);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <Card mb={6}>
          <CardHeader title={t("edit_employee")} subheader={breadCrump()} />
          <CardContent>
            {status && status.sent && (
              <Alert severity="success" my={3}>
                employee updated successfully!
              </Alert>
            )}

            {isSubmitting ? (
              <Box display="flex" justifyContent="center" my={6}>
                <CircularProgress />
              </Box>
            ) : (
              <form onSubmit={handleSubmit(onSubmit)}>
                <Tabs
                  classes={{ scroller: classes.scroller }}
                  value={tabValue}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="tenant"
                  sx={{
                    justifyContent: "center",
                    width: {
                      xs: "100%", // Full width on mobile devices
                      sm: "500px", // Fixed width on small devices
                      md: "700px", // Wider on medium devices
                      lg: "900px", // Even wider on larger devices
                    },
                    minWidth: "300px", // Ensure a minimum width across all devices
                    maxWidth: "100%", // Ensure it doesn't overflow the container
                  }}
                >
                  {" "}
                  <Tab label="Employee Details" {...a11yProps(0)} />
                  <Tab label="Menu Acl" {...a11yProps(0)} />
                </Tabs>
                <TabPanel value={tabValue} index={0}>
                  <EmployeeFields fields={validationSchema.fields} />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                  <MenuAclFields
                    fields={validationSchema.fields}
                    selectedPermissions={selectedPermissions}
                    setSelectedPermissions={setSelectedPermissions}
                    employeeUserName={employee?.userName}
                  />
                </TabPanel>
                <SaveCancel cancelBtn={cancelBtn} resetForm={reset} />
              </form>
            )}
          </CardContent>
        </Card>
      </FormProvider>
    </React.Fragment>
  );
}

export default EditEmployee;
